import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  create: item =>
    api
      .send({
        query: gql`
          mutation createReceptor($item: ReceptorInput!) {
            Receptor {
              create(input: $item) {
                id
              }
            }
          }
        `,
        variables: {
          item
        }
      })
      .then(result => result.data.data.Receptor.create),

  addExoneracion: input =>
    api
      .send({
        query: gql`
          mutation addExoneracion($input: ReceptorExoneracionInput!) {
            Receptor {
              addExoneracion(input: $input) {
                exoneracion {
                  id
                }
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Receptor.addExoneracion),

  readByNombreIdentificacion: nid =>
    api
      .send({
        query: gql`
          query readByNombreIdentificacion($nid: String!) {
            Receptor {
              readByNombreIdentificacion(nid: $nid) {
                id
                nombre
                identificacion {
                  tipo {
                    id
                  }
                  numero
                }
                ubicacion {
                  provincia {
                    id
                  }
                  canton {
                    id
                  }
                  distrito {
                    id
                  }
                  otrasSenas
                }
                identificacionExtranjero
                nombreComercial
                telefono {
                  codigoPais
                  numTelefono
                }
                correoElectronico
                actividades {
                  estado
                  tipo
                  codigo
                  descripcion
                }
                exoneracion {
                  tipoDocumentoEX1 {
                    id
                    value
                    annotation
                  }
                  numeroDocumento
                  nombreInstitucion
                  fechaEmisionEX
                  tarifaExonerada
                }
              }
            }
          }
        `,
        variables: {
          nid
        }
      })
      .then(result => result.data.data.Receptor.readByNombreIdentificacion)
}
